<template>
  <div>
    <!-- Pagination -->
    <div class="row">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
      <div class="col-md-6 text-md-right mt-2 mt-md-0">
        Sort by
        <select
          class="custom-select custom-select-sm"
          v-model="sortBy"
          style="width: 9.4em"
        >
          <option value="action">Action Date</option>
          <option value="subject">Class Subject</option>
          <option value="subjectLevel">Subject Level</option>
          <option value="duration">Duration</option>
          <option value="student">Name</option>
          <option value="email">Email</option>
          <option value="createdDate">Created Date</option>
          <option value="status">Status</option>
          <option value="date">Class Date</option>
          <option value="time">Class Time</option>
          <option value="makeup">Make-up Class</option>
          <option value="location">Location</option>
        </select>
        <select
          class="custom-select custom-select-sm"
          v-model="sortDirection"
          style="width: 8em"
        >
          <option value="asc">Ascending</option>
          <option value="desc">Descending</option>
        </select>
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Result -->
    <div class="card my-3" v-for="item in classBookings" :key="item.Id">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-4">
            <label class="mb-0"><b>Class Subject:</b></label>
            {{ item.SubjectName }}
          </div>
          <div class="col-sm-4">
            <label class="mb-0"><b>Subject Level:</b></label>
            {{ item.SubjectLevelName }}
          </div>
          <div class="col-sm-4">
            <label class="mb-0"><b>Duration:</b></label>
            {{ item.Duration }}
          </div>
        </div>
      </div>
      <div class="card-body pt-2 pb-0">
        <div class="row">
          <div class="col-md-10">
            <div class="form-row">
              <div class="form-group col-md-3">
                <label class="mb-0"><b>Name</b></label>
                <div>{{ item.StudentName }}</div>
              </div>
              <div class="form-group col-md-3">
                <label class="mb-0"><b>Email</b></label>
                <div>{{ item.StudentEmail }}</div>
              </div>
              <div class="form-group col-md-3">
                <label class="mb-0"><b>Created Date</b></label>
                <div>{{ item.SubmittedDateDisplay }}</div>
              </div>
              <div class="form-group col-md-3">
                <label class="mb-0"><b>Status</b></label>
                <div>{{ item.Status }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-3">
                <label class="mb-0"><b>Class Date</b></label>
                <div>{{ item.BookingDateDisplay }}</div>
              </div>
              <div class="form-group col-md-3">
                <label class="mb-0"><b>Class Time</b></label>
                <div>{{ item.BookingTime }}</div>
              </div>
              <div class="form-group col-md-3">
                <label class="mb-0"><b>Make-up Class</b></label>
                <div>{{ item.MakeupClass }}</div>
              </div>
              <div class="form-group col-md-3">
                <label class="mb-0"><b>Location</b></label>
                <div>{{ item.Location }}</div>
              </div>
            </div>
          </div>
          <div class="col-md-2 my-md-auto">
            <div class="row mb-3">
              <div class="form-group col-6 mb-0 text-right">
                <button
                  class="btn btn-sm btn-success"
                  @click="confirm(item.Id)"
                  :disabled="
                    item.Status == 'Cancelled' || item.Status == 'Confirmed'
                  "
                >
                  Confirm
                </button>
              </div>
              <div class="form-group col-6 mb-0">
                <button
                  class="btn btn-sm btn-danger"
                  @click="cancel(item.Id)"
                  :disabled="item.Status == 'Cancelled'"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div class="row" v-if="item.CanChangeToPending">
              <div class="form-group col-12 text-center">
                <button
                  class="btn btn-sm btn-secondary mb-0"
                  @click="changeToPending(item.Id)"
                >
                  Change to Pending Confirmation
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="classBookings && !classBookings.length" class="card mt-2">
      <div class="card-body text-center">{{ noRecordText }}</div>
    </div>
    <!-- /Result -->

    <!--Pagination -->
    <div
      style="margin-top: -8px"
      class="row mb-4"
      v-if="classBookings && classBookings.length"
    >
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          classBookings.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config";
export default {
  props: [
    "studentName",
    "subjectName",
    "subjectLevelName",
    "duration",
    "makeupClass",
    "startDate",
    "endDate",
    "startTimeHour",
    "startTimeMinute",
    "startTimePart",
    "endTimeHour",
    "endTimeMinute",
    "endTimePart",
    "statuses",
    "instructorId",
  ],
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      classBookings: [],
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      sortBy: "action",
      sortDirection: "desc",
      totalRecords: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
  },
  watch: {
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getClassBookingList();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
    sortBy(val) {
      this.paging.CurrentPage = 1;
      if (this.sortDirection == "desc") this.paging.SortBy = `${val}_desc`;
      else this.paging.SortBy = val;
      this.getClassBookingList();
    },
    sortDirection(val) {
      this.paging.CurrentPage = 1;
      if (val == "desc") this.paging.SortBy = `${this.sortBy}_desc`;
      else this.paging.SortBy = this.sortBy;
      this.getClassBookingList();
    },
  },
  methods: {
    getClassBookingList() {
      let param = {
        Token: this.tokenObj.Token,
        CurrentPage: this.paging.CurrentPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        SchoolId: this.tokenObj.SchoolId,
        SubjectName: this.subjectName,
        SubjectLevelName: this.subjectLevelName,
        Duration: this.duration,
        MakeupClass: this.makeupClass,
        StudentName: this.studentName,
        StartDate: this.startDate,
        EndDate: this.endDate,
        StartTimeHour: this.startTimeHour,
        StartTimeMinute: this.startTimeMinute,
        StartTimePart: this.startTimePart,
        EndTimeHour: this.endTimeHour,
        EndTimeMinute: this.endTimeMinute,
        EndTimePart: this.endTimePart,
        Statuses: this.statuses,
        InstructorId: this.instructorId,
      };
      this.$store.state.isLoading = true;
      API.classBooking
        .getClassBookingList(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.classBookings = response.data.data;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    cancel(id) {
      let param = {
        Token: this.tokenObj.Token,
        Id: id,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to cancel the class booking?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.classBooking
            .cancelClassBooking(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) this.getClassBookingList();
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    confirm(id) {
      let param = {
        Token: this.tokenObj.Token,
        Id: id,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to confirm the class booking?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.classBooking
            .confirmClassBooking(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) this.getClassBookingList();
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    changeToPending(id) {
      let param = {
        Token: this.tokenObj.Token,
        Id: id,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to change the class booking to Pending Confirmation?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.classBooking
            .changeClassBookingToPending(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) this.getClassBookingList();
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    //pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getClassBookingList();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getClassBookingList();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getClassBookingList();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getClassBookingList();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getClassBookingList();
    },
  },
  created() {
    this.getClassBookingList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SchoolUser/Instructor/MyScheduleTableFormat.vue